
<f-dialog
    v-if          = "data"
    v-model       = "show"
    :width        = "1200"
    :show-header  = "true"
    :show-save    = "true"
    :title        = "title"
    store-label   = "Drucken"
    @store        = "onPrint"
    @cancel       = "onCancel"
>
    <template v-slot:content>
        <v-form ref="form">
            <v-row dense class="mt-0">
                <v-col class="no-frame pr-2 col-4">
                    <f-title
                        title="Bauvorhaben"
                    />
                    <div class="box-first-row">
                        <v-row dense>
                            <v-col class="no-frame">
                                <f-read-only-field
                                    label  = "VE2"
                                    :value = "data.site.ve2"
                                    style="margin-top: -1px"
                                />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col class="no-frame">
                                <f-read-only-field
                                    label  = "Strasse"
                                    :value = "data.site.street"
                                    style="margin-top: -1px"
                                />
                            </v-col>
                        </v-row>
                        <v-row dense class="mb-4">
                            <v-col class="no-frame col-4 pr-2">
                                <f-read-only-field
                                    label  = "PLZ"
                                    :value = "data.site.zip"
                                    dense
                                />
                            </v-col>
                            <v-col class="no-frame col-8 pl-2">
                                <f-read-only-field
                                    label  = "Ort"
                                    :value = "data.site.city"
                                    dense
                                />
                            </v-col>
                        </v-row>
                    </div>

                    <!-- beneficiary -->
                    <f-title
                        title="Auftraggeber"
                        class="mt-4"
                    />
                    <div class="box" >
                        <v-row dense>
                            <v-col class="no-frame">
                                <f-read-only-field
                                    label  = "Name"
                                    :value = "data.beneficiary.name"
                                    style="margin-top: -1px"
                                />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col class="no-frame">
                                <f-read-only-field
                                    label  = "Strasse"
                                    :value = "data.beneficiary.street"
                                    style="margin-top: -1px"
                                />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col class="no-frame col-4 pr-2">
                                <f-read-only-field
                                    label  = "PLZ"
                                    :value = "data.beneficiary.zip"
                                    style="margin-top: -1px"
                                />
                            </v-col>
                            <v-col class="no-frame col-8 pl-2">
                                <f-read-only-field
                                    label  = "Ort"
                                    :value = "data.beneficiary.city"
                                    style="margin-top: -1px"
                                />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col class="no-frame col-6 pr-2">
                                <v-text-field
                                    label          = "Telefon"
                                    v-model        = "data.beneficiary.tel"
                                    :rules        = "[ requiredRule ]"
                                    autocomplete   = "off"
                                    autocorrect    = "off"
                                    autocapitalize = "off"
                                    spellcheck     = "false"
                                />
                            </v-col>
                            <v-col class="no-frame col-6 pl-2">
                                <v-text-field
                                    label          = "Fax"
                                    v-model        = "data.beneficiary.fax"
                                    :rules        = "[ requiredRule ]"
                                    autocomplete   = "off"
                                    autocorrect    = "off"
                                    autocapitalize = "off"
                                    spellcheck     = "false"
                                />
                            </v-col>
                        </v-row>
                    </div>
                </v-col>

                <v-col class="no-frame col-4 pr-2">
                    <!-- subject of the contract -->
                    <f-title
                        title="Vertragsgegenstand"
                        class="mt-0"
                    />
                    <div style="margin-top: -16px;">
                        <v-row dense>
                            <v-col class="no-frame">
                                <div class="lm-border pa-2 mt-4" style="height: 84px">
                                    {{ data.bid.measure }}
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                    <!-- subject of the contract -->

                    <!-- Terms and deadlines -->
                    <f-title
                        title="Fristen und Termine"
                        class="mt-4"
                    />
                    <div class="lm-border pa-3" style="height: 134px">
                        <v-row dense>
                            <v-col class="no-frame">
                                <f-date-picker
                                    label         = "repair.bid.date"
                                    v-model       = "data.bid.date"
                                    :rules        = "[ requiredRule ]"
                                    :hide-details = "true"
                                />
                            </v-col>
                        </v-row>
                        <v-row class="no-frame mb-4 mt-3">
                            <v-col class="no-frame mr-2">
                                <f-date-picker
                                    label         = "repair.bid.deadline.begin"
                                    v-model       = "data.date1"
                                    :hide-details = "true"
                                />
                            </v-col>
                            <v-col class="no-frame ml-2">
                                <f-date-picker
                                    label         = "repair.bid.deadline.end"
                                    v-model       = "data.date2"
                                    :hide-details = "true"
                                />
                            </v-col>
                        </v-row>
                    </div>
                    <!-- Terms and deadlines -->

                    <!-- contractor -->
                    <f-title
                        title="Auftragnehmer"
                        class="mt-4"
                    />
                    <div class="box">
                        <v-row dense>
                            <v-col class="no-frame">
                                <f-read-only-field
                                    label  = "Name"
                                    :value = "data.contractor.name"
                                    style="margin-top: -1px"
                                />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col class="no-frame">
                                <f-read-only-field
                                    label  = "Strasse"
                                    :value = "data.contractor.street"
                                    style="margin-top: -1px"
                                />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col class="no-frame col-4 pr-2">
                                <f-read-only-field
                                    label  = "PLZ"
                                    :value = "data.contractor.zip"
                                    style="margin-top: -1px"
                                />
                            </v-col>
                            <v-col class="no-frame col-8 pl-2">
                                <f-read-only-field
                                    label  = "Ort"
                                    :value = "data.contractor.city"
                                    style="margin-top: -1px"
                                />
                            </v-col>
                        </v-row>
                    </div>
                    <!-- contractor -->
                </v-col>

                <v-col class="no-frame col-4">

                    <!-- recommended bid -->
                    <f-title
                        title="Empfohlenes Angebot"
                        class="mt-0"
                    />
                    <div class="box-first-row">
                        <v-row dense>
                            <v-col class="no-frame col-6 pr-2">
                                <f-currency-field
                                    v-model   = "data.bid.recommended"
                                    :readonly = "true"
                                    label="Auftragssumme"
                                    class="money"
                                    :hide-details="true"
                                />
                            </v-col>
                            <v-col class="no-frame col-6 pr-2">
                                <f-currency-field
                                    v-if      = "data.bid.amount"
                                    v-model   = "data.bid.amount"
                                    :readonly = "true"
                                    class     = "money"
                                    label     = "Angebotspreis (Ursprung)"
                                    hide-details="true"
                                />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col class="no-frame col-6 pr-2">
                                <div style="height: 25px; padding-top: 4px; text-align: right">
                                    Nachlass {{ data.discountAmount }} %
                                </div>
                            </v-col>
                            <v-col class="no-frame col-6 pr-2">

                            </v-col>
                        </v-row>
                        <v-row dense class="mt-8">
                            <v-col class="no-frame">
                                <v-checkbox
                                    label="pauschal"
                                    v-model="data.flatAgreed"
                                    :ripple = "false"
                                    dense
                                    hide-details
                                />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col class="no-frame">
                                <v-checkbox
                                    label="nach Aufwand"
                                    :ripple = "false"
                                    v-model="data.effortAgreed"
                                    dense
                                    hide-details
                                />
                            </v-col>
                        </v-row>
                    </div>
                    <!-- recommended bid -->
                </v-col>
            </v-row>
        </v-form>
    </template>
</f-dialog>
